<template>
  <div class="container">
    <div class="page404">
      <div><img src="@/assets/bg/page404.png" alt="404页面" /></div>
      <el-button class="back" @click="back" round>返回</el-button>
    </div>
  </div>
</template>
<script>
import './styles/mobile.scss';
export default {
  name: 'page404',
  data() {
    return {};
  },
  methods: {
    back() {
      this.$router.push('/');
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  .page404 {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .back {
    width: 124px;
    height: 40px;
    margin-top: 20px;
    border: 1px solid #2c57ec;
  }
}
</style>
